// hooks/useCookieConsent.js
import { useState, useEffect } from "react";

export function useCookieConsent() {
  const [consent, setConsent] = useState(null); // null = undecided, true/false = user choice

  useEffect(() => {
    const saved = localStorage.getItem("cookieConsent");
    if (saved !== null) {
      setConsent(saved === "true");
    }
  }, []);

  const accept = () => {
    localStorage.setItem("cookieConsent", "true");
    setConsent(true);
  };

  const reject = () => {
    localStorage.setItem("cookieConsent", "false");
    setConsent(false);
  };

  return { consent, accept, reject };
}
